import { render, staticRenderFns } from "./GradingPlanForm.vue?vue&type=template&id=4cfb02f1&"
import script from "./GradingPlanForm.vue?vue&type=script&lang=js&"
export * from "./GradingPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports